<template>
  <div>
    <v-row>
      <v-col v-for="item in postWatches" :key="item.post.id">
        <v-card
            class="mx-auto"
            width="400"
        >
          <v-img
              class=" white--text align-end"
              height="200px"
              :src="item.post.url"
          >
          </v-img>

          <v-card-subtitle class="pb-0">{{ item.post.title | truncate(50)}}</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>r/{{ item.post.subreddit }}</div>
          </v-card-text>

          <v-card-actions>

            <v-btn
                color="orange"
                text
                @click="enableDisableOnClick(item.watch)"
            >
              {{item.watch.enabled ? 'Disable' : 'Enable'}}
            </v-btn>
            <v-btn
                color="orange"
                text
                @click="deleteOnClick(item.watch)"
            >
              Delete
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                text
                :href="`https://redd.it/` + item.post_id"
                target="_blank"
            >
              View Post
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
        v-model="confirmDelete"
        max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Are You Sure?</v-card-title>

        <v-card-text>
          This will permanently remove this watch from our system.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="green darken-1"
              text
              @click="confirmDelete = false"
          >
            Nope
          </v-btn>

          <v-btn
              color="green darken-1"
              text
              @click="confirmDeleteWatchOnClick"
          >
            Go For It
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PostWatchGrid",
  data: () => ({
    confirmDelete: false,
    selectedWatch: null
  }),
  props: {
    postWatches: Array[Object]
  },
  methods: {
    enableDisableOnClick(item) {
      item.enabled = !item.enabled
      this.$emit('update-watch', item);
    },
    confirmDeleteWatchOnClick() {
      this.confirmDelete = false;
      this.$emit('delete-watch', this.selectedWatch);
      this.selectedWatch = null;
    },
    deleteOnClick(item) {
      this.selectedWatch = item;
      this.confirmDelete = true;
    }
  }
}
</script>

<style scoped>

</style>